import { render } from "./ItemPrice.vue?vue&type=template&id=af14c11a&scoped=true"
import script from "./ItemPrice.vue?vue&type=script&lang=ts"
export * from "./ItemPrice.vue?vue&type=script&lang=ts"

import "./ItemPrice.vue?vue&type=style&index=0&id=af14c11a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-af14c11a"

export default script